module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp2_6005.f414c8dc.png";